import { ArrowBack } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useBack } from "@refinedev/core";

export const BackButton: React.FC<{ showUnsavedWarning: boolean }> = ({
  showUnsavedWarning,
}) => {
  const goBack = useBack();
  return (
    <IconButton
      onClick={() => {
        if (showUnsavedWarning) {
          const ok = window.confirm(
            "के तपाईं साँच्चै छोड्न चाहनुहुन्छ? तपाईंसँग सुरक्षित नगरिएका परिवर्तनहरू छन्।"
          );
          if (!ok) return;
        }

        goBack();
      }}
    >
      <ArrowBack />
    </IconButton>
  );
};
